/**
 * @desc 库存锁定/解锁
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.LockStockRootRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderPackage/lockStock`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
